/*
 * FS | Gift set interrupt
 *
 * Intercepts the focal Add-to-Cart click (PDP, quick-view drawer, collection instant-add)
 * for products that have an FS | Gift set configured, and shows a modal BEFORE anything is
 * added to cart. The shopper chooses:
 *   - "Add the gift set"          -> the modal's own instant-add (theme add + cart drawer opens)
 *   - "No thanks, add <product>"  -> the original add is re-dispatched unchanged
 *
 * Association: a focal add button is intercepted when its closest [data-fs-giftset-scope]
 * ancestor contains a [data-fs-giftset-modal] (rendered only for gift-set-eligible products).
 * Gift-set add buttons carry [data-fs-giftset-add] and are never intercepted.
 */
(function () {
  if (window.__fsGiftsetInterrupt) return;
  window.__fsGiftsetInterrupt = true;

  var ADD_SELECTOR = '[data-fs-atc-button],[data-fs-mobile-atc-btn],[data-add-to-cart]';
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';

  var bypass = false; // true while we re-dispatch the original add so we don't re-intercept
  var pendingBtn = null; // the focal add button we intercepted (re-dispatch target)
  var trigger = null; // element to return focus to when the modal is dismissed

  function openModal(modal) {
    if (!modal) return;
    modal.hidden = false;
    void modal.offsetWidth; // reflow so the transition runs
    modal.classList.add('is-open');
    document.documentElement.classList.add('fs-giftset-modal-open');
    var focusTarget = modal.querySelector('[data-fs-giftset-continue]') || modal.querySelector(FOCUSABLE);
    if (focusTarget) {
      try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); }
    }
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.hidden = true;
  }

  function closeAll(refocus) {
    var open = document.querySelectorAll('[data-fs-giftset-modal]:not([hidden])');
    for (var i = 0; i < open.length; i++) closeModal(open[i]);
    document.documentElement.classList.remove('fs-giftset-modal-open');
    pendingBtn = null;
    if (refocus && trigger && document.contains(trigger)) {
      try { trigger.focus({ preventScroll: true }); } catch (e) { trigger.focus(); }
    }
    trigger = null;
  }

  // Capture-phase: catch the focal add before the theme's own add handler runs.
  document.addEventListener(
    'click',
    function (e) {
      if (bypass) {
        bypass = false;
        return; // allow the re-dispatched original add through
      }

      var btn = e.target.closest(ADD_SELECTOR);
      if (!btn) return;
      if (btn.hasAttribute('data-fs-giftset-add')) return; // a gift-set add, never intercept
      if (btn.closest('[data-fs-giftset-modal]')) return; // anything inside a modal

      var scope = btn.closest('[data-fs-giftset-scope]');
      if (!scope) return;
      var modal = scope.querySelector('[data-fs-giftset-modal]');
      if (!modal) return; // product has no gift set -> let the add proceed

      e.preventDefault();
      e.stopImmediatePropagation();

      pendingBtn = btn;
      trigger = btn;
      openModal(modal);
    },
    true
  );

  // Bubble-phase: modal controls.
  document.addEventListener('click', function (e) {
    var cont = e.target.closest('[data-fs-giftset-continue]');
    if (cont) {
      e.preventDefault();
      closeModal(cont.closest('[data-fs-giftset-modal]'));
      document.documentElement.classList.remove('fs-giftset-modal-open');
      var b = pendingBtn;
      pendingBtn = null;
      trigger = null;
      if (b) {
        bypass = true;
        b.click(); // re-dispatch the original add, unchanged (qty, variant, properties intact)
      }
      return;
    }

    if (e.target.closest('[data-fs-giftset-close]')) {
      e.preventDefault();
      closeAll(true);
    }
  });

  // Keyboard: Escape to dismiss, Tab trapped inside the open modal.
  document.addEventListener('keydown', function (e) {
    var modal = document.querySelector('[data-fs-giftset-modal]:not([hidden])');
    if (!modal) return;

    if (e.key === 'Escape' || e.keyCode === 27) {
      closeAll(true);
      return;
    }

    if (e.key === 'Tab' || e.keyCode === 9) {
      var items = Array.prototype.filter.call(
        modal.querySelectorAll(FOCUSABLE),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // The gift-set add (or the re-dispatched original add) fires this once it lands in the cart.
  document.addEventListener('theme:cart:change', function () { closeAll(false); });
})();
